import { mapState, mapGetters } from 'vuex';
import coupon from '@mixins/officialStore/coupon';
import { UPDATE_IS_CART } from '@store/officialStore/cart';
import {
  SET_SHOW_CHANNEL_STATUS,
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_LOADING,
  UPDATE_HAS_SELECT_PRODUCT
} from '@store/officialStore';
import { ZTMSLG_GAMES } from '@configs/officialStore/globalGameInfoConfig';
import { commonEmitUpload } from '../../plugins/AnalyzePoint/index';
import { clickButton } from '@plugins/biPoint/_configWebstoreV1';
export default {
  mixins: [coupon],
  computed: {
    ...mapState({
      hasLoadPaytype: state => state.hasLoadPaytype,
      canUseCart: state => state.cart.canUseCart,
      isCart: state => state.cart.isCart,
      cartList: state => state.cart.cartList,
      gameId: state => state.gameId
    }),
    ...mapGetters(['cartTotalQuantity', 'gameInfoConfig']),
    isCustomProductType() {
      return this.gameInfoConfig.isCustomProductType;
    },
    hasValidGameCoupon() {
      return this.gameCouponEnableList?.length > 0;
    },
    showUseCartGuideTip() {
      if (
        ZTMSLG_GAMES.includes(this.gameId) &&
        this.hasLoadPaytype &&
        this.canUseCart &&
        this.hasValidGameCoupon &&
        (!this.isCart || (this.isCart && this.cartTotalQuantity === 1))
      ) {
        commonEmitUpload('show-use-cart-guide', {
          event: 'show-use-cart-guide',
          newPage: false,
          type: 'click'
        });
        return true;
      }
      return false;
    }
  },
  methods: {
    handleUseCartGuide() {
      clickButton({
        btnName: 'go_addon_product'
      });
      this.reSelectProduct();
    },
    handleReSelectProduct() {
      clickButton({
        btnName: 'back_select_product'
      });
      this.reSelectProduct();
    },
    reSelectProduct() {
      if (this.cartList.length > 0) {
        this.$store.commit(UPDATE_IS_CART, true);
      }
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_LOADING, false);
      this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
      if (this.isCustomProductType) {
        this.$nextTick(() => {
          this?.scroll?.refresh();
        });
      }
    }
  }
};
